export interface AppBrand {
  id: 'koubo';
  name: string;
  shortName: string;
  title: string;
  homeAriaLabel: string;
  logoSrc: string;
  markSrc: string;
  faviconSrc: string;
}

export const DEFAULT_BRAND: AppBrand = {
  id: 'koubo',
  name: '口播王',
  shortName: '口播王',
  title: '口播王',
  homeAriaLabel: '口播王首页',
  logoSrc: '/brand/koubo-wang-logo-144.webp',
  markSrc: '/brand/koubo-wang-mark-144.webp',
  faviconSrc: '/brand/koubo-wang-favicon-64.png',
};

export function getCurrentBrand(): AppBrand {
  return DEFAULT_BRAND;
}

export function applyBrandToDocument(brand: AppBrand = getCurrentBrand()): void {
  if (typeof document === 'undefined') return;

  document.title = brand.title;
  const favicon =
    document.querySelector<HTMLLinkElement>('link[rel="icon"]') ?? document.createElement('link');
  favicon.rel = 'icon';
  favicon.type = 'image/png';
  favicon.href = brand.faviconSrc;
  if (!favicon.parentElement) {
    document.head.appendChild(favicon);
  }
}
